<script setup lang="ts">
import { Policy } from "@/modules/groups/interfaces/policy";
import { type PolicyTypes, POLICY_TYPES } from "@/enums/policyTypes";
import { computed } from "vue";

interface Props {
  type: PolicyTypes;
  policy: Policy;
}

const props = defineProps<Props>();
const lowercaseDescription = computed((): string => {
  return props.policy.description.toLowerCase();
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="grid gap-1">
      <h3 class="font-semibold">{{ policy.displayName }}</h3>
      <hr class="border-gray-300" />
    </div>

    <p><span class="text-sm font-semibold">Descripción:</span> {{ lowercaseDescription }}</p>

    <template v-if="type === POLICY_TYPES.VALUE">
      <p>Valor: {{ policy.rule[0].value }}</p>
    </template>

    <template v-if="type === POLICY_TYPES.RANGE">
      <div class="flex items-center gap-4">
        <p>Mínimo: {{ policy.rule[0].min }}</p>
        <p>Máximo: {{ policy.rule[0].max }}</p>
      </div>
    </template>

    <template v-if="type == POLICY_TYPES.MULTIPLE">
      <ul class="flex flex-wrap items-center gap-4 gap-y-2">
        <template v-for="value in policy.rule[0].options" :key="value">
          <li
            class="p-1 px-1.5 border rounded-md hover:bg-gray-100 fade-transition"
          >
            {{ value }}
          </li>
        </template>
      </ul>
    </template>
  </div>
</template>

<style scoped></style>
